import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { RecurringExpensesPanel } from './RecurringExpenses';
import { OneTimeExpensesPanel } from './OneTimeExpenses';

// The Expenses page (spec §10.2 + §10.6). Two tabs over the shared cost surface: RECURRING
// (licenses/subscriptions — the s44/s45 derived engine) and ONE-TIME (general multi-vendor
// purchases with per-line client/project attribution — slice 5). Each tab is a self-contained panel.

type Tab = 'recurring' | 'onetime';

const TABS: ReadonlyArray<readonly [Tab, string]> = [
  ['recurring', 'Recurring'],
  ['onetime', 'One-time'],
];

export function AdminExpenses(): JSX.Element {
  // s77 #16b: a per-line "view expense" deep link (?focus=) lands on the one-time tab, where billable
  // pulled expense lines live.
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState<Tab>(searchParams.get('focus') ? 'onetime' : 'recurring');
  return (
    <div className="mx-auto max-w-6xl px-4 py-8 space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Expenses</h1>
        <p className="text-sm text-[var(--color-muted)]">
          What you pay vendors: recurring licenses and subscriptions, plus one-time and general
          purchases. These feed profitability; a line marked billable can be charged to a client.
        </p>
      </div>
      <div className="flex gap-1 border-b border-[rgb(var(--edge-rgb)/0.10)]">
        {TABS.map(([key, label]) => (
          <button
            key={key}
            type="button"
            onClick={() => setTab(key)}
            className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium transition ${
              tab === key
                ? 'border-[var(--color-primary)] text-[var(--color-text)]'
                : 'border-transparent text-[var(--color-muted)] hover:text-[var(--color-text)]'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      {tab === 'recurring' ? <RecurringExpensesPanel /> : <OneTimeExpensesPanel />}
    </div>
  );
}
